'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ItemPickerController=class ItemPickerController{
static get $inject(){
return['$scope'];
}

constructor($scope){
this.items=this.items||[];
this._selectedItem=this.selectedItem||void 0;
this.selectedIndex=this.selectedIndex||-1;

$scope.$watchGroup([
'controller.items',
'controller.selectedItem',
'controller.selectedIndex'],
()=>this._reevaluateSelection());

this._reevaluateSelection();
}

_reevaluateSelection(){
if(_.exists(this.items)&&this.items.length>0&&!_.exists(this.selectedItem)){
this.selectedItem=this.items[0];
}

const newIndex=this.items.indexOf(this.selectedItem);
if(this.selectedIndex!==newIndex){
this.selectedIndex=newIndex;
}

if(this.selectedIndex===-1){
this.selectedItem=void 0;
}
}

goToNextItem(){
if(this.selectedIndex<this.items.length-1){
this.selectedIndex+=1;
this.selectedItem=this.items[this.selectedIndex];
}
}

goToPreviousItem(){
if(this.selectedIndex>0){
this.selectedIndex-=1;
this.selectedItem=this.items[this.selectedIndex];
}
}

get selectedItem(){
return this._selectedItem;
}

set selectedItem(selectedItem){
if(this._selectedItem===selectedItem)
return;

this._selectedItem=selectedItem;
}};let


ItemPickerDirective=class ItemPickerDirective extends BaseControllerBackedDirective{
get templateUrl(){throw new Error('Please supply a template url.')}
get objectBindings(){return['items','selectedIndex','selectedItem','itemFormatter']}
get controller(){
return ItemPickerController;
}};


module.exports=ItemPickerDirective;
module.exports.DirectiveController=ItemPickerController;
//# sourceMappingURL=itemPickerDirective.js.map
